import { ArrowUpRight } from "lucide-react";

export default function ProjectCard({ project, i = 0, dark = false }) {
    const p = project;
    const hasLink = p.show_link && p.link;

    const titleRow = (
        <div className="mt-5 flex items-start justify-between gap-3">
            <h3
                className={`font-display text-lg md:text-xl leading-tight ${
                    dark ? "text-paper" : "text-ink"
                }`}
            >
                {p.title}
            </h3>
            <ArrowUpRight
                className={`h-5 w-5 shrink-0 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 ${
                    dark
                        ? "text-paper/50 group-hover:text-sage"
                        : "text-muted2 group-hover:text-ink"
                }`}
            />
        </div>
    );

    return (
        <article
            data-testid={`project-card-${p.slug}`}
            className="group flex flex-col"
        >
            <div
                className={`overflow-hidden border aspect-[4/3] ${
                    dark ? "border-linedark" : "border-line"
                }`}
            >
                {hasLink ? (
                    <a
                        href={p.link}
                        target="_blank"
                        rel="noreferrer"
                        data-testid={`project-image-link-${p.slug}`}
                        className="block h-full w-full"
                    >
                        <img
                            src={p.image}
                            alt={p.title}
                            loading="lazy"
                            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                        />
                    </a>
                ) : (
                    <img
                        src={p.image}
                        alt={p.title}
                        loading="lazy"
                        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                )}
            </div>

            {hasLink ? (
                <a
                    href={p.link}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`project-link-${p.slug}`}
                    className="block"
                >
                    {titleRow}
                </a>
            ) : (
                titleRow
            )}

            <p
                className={`mt-1 text-sm ${
                    dark ? "text-paper/60" : "text-muted2"
                }`}
            >
                {p.subtitle}
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
                {(p.tags || []).map((tag) => (
                    <span
                        key={tag}
                        className={`mono text-[10px] tracking-wide border rounded-full px-3 py-1.5 transition-colors duration-300 ${
                            dark
                                ? "border-paper/25 text-paper/70 group-hover:border-sage group-hover:text-sage"
                                : "border-line text-muted2 group-hover:border-ink group-hover:text-ink"
                        }`}
                    >
                        {tag}
                    </span>
                ))}
            </div>
        </article>
    );
}
